import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from "../../config/config";
import {map} from 'rxjs/operators';

@Injectable()
export class StudentProfileViewService {

  private _url = AppSettings.API_ENDPOINT;
  constructor(private http: HttpClient) {
  }

  //update student details
  getStudentProfilePrintDetails(studentId, AUTHTOKEN) {
    let params = {studentId:studentId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/studentprofileprintdetails',
      params, {headers: headers})
      .pipe(map(res => res));
  }
}
